
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EPermissionActions } from '@/model/EPermissionActions';
import { IAuthUserData } from '@/store/modules/authModule';

const authModule = namespace('authModule');

interface NavTab {
  route: string;
  icon: string;
  labelKey: string;
  label?: string;
  action?: string;
}

@Component({ name: 'UserNav' })
export default class UserNav extends Vue {
  @Prop()
  protected userId!: number;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  private allTabs: NavTab[] = [
    { route: 'user', icon: 'mdi-account', labelKey: 'users.nav.general' },
    { route: 'userEdit', icon: 'mdi-pencil', labelKey: 'users.nav.edit', action: EPermissionActions.ACTION_USERS_UPDATE },
    { route: 'userOrderLists', icon: 'mdi-package-variant-closed', labelKey: 'users.nav.orders' },
    { route: 'userCommunications', icon: 'mdi-email-outline', labelKey: 'users.nav.communications' },
    { route: 'userPromotions', icon: 'mdi-tag-outline', labelKey: 'users.nav.promotions' },
    { route: 'userAddresses', icon: 'mdi-home-city', labelKey: 'users.nav.addresses', action: EPermissionActions.ACTION_USERS_UPDATE },
    { route: 'userMgm', icon: 'mdi-account-multiple', labelKey: 'users.nav.mgm', action: EPermissionActions.ACTION_USERS_UPDATE },
    { route: 'userPermissions', icon: 'mdi-account-key', labelKey: 'users.nav.permissions', action: EPermissionActions.ACTION_USERS_PERMISSIONS },
    { route: 'userWebhooks', icon: 'mdi-link', labelKey: 'menu.webhooks.title', action: EPermissionActions.ACTION_ORDERS_WEBHOOK },
    { route: 'userAuditLogs', icon: 'mdi-history', labelKey: 'users.nav.auditLogs', action: EPermissionActions.ACTION_USERS_LOGS },
  ];

  get isSelf(): boolean {
    return '' + this.userId === '' + this.authUser.id;
  }

  get visibleTabs(): NavTab[] {
    return this.allTabs
      .filter(tab => {
        if (tab.action && !this.$canAction(tab.action)) return false;
        return true;
      })
      .map(tab => ({
        ...tab,
        label: this.$t(tab.labelKey) as string,
      }));
  }

  get activeTabIndex(): number {
    const currentRoute = this.$route.name;
    return this.visibleTabs.findIndex(tab => tab.route === currentRoute);
  }

  isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
